import { useSelector } from 'react-redux';

import { selectFeatureFlags } from '@/model/selectors';

export function useHasAdvisorLogoBranding() {
  const featureFlags = useSelector(selectFeatureFlags);

  return !!featureFlags.advisorLogoBranding;
}
